import { format as fnsFormat, parseISO, isValid } from "date-fns";

/**
 * Safe date formatter - handles invalid dates gracefully
 * Returns formatted string or fallback
 */
export function safeFormat(dateValue, formatStr = 'EEE d MMM, HH:mm', fallback = '-') {
  if (!dateValue) return fallback;
  try {
    let d;
    if (dateValue instanceof Date) {
      d = dateValue;
    } else if (typeof dateValue === 'string') {
      // Try ISO parse first
      d = parseISO(dateValue);
      // If invalid, try DD/MM/YYYY HH:mm
      if (!isValid(d)) {
        const match = dateValue.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})\s*(\d{1,2})?:?(\d{2})?/);
        if (match) {
          const [, day, month, year, hour = '0', min = '0'] = match;
          d = new Date(year, parseInt(month) - 1, parseInt(day), parseInt(hour), parseInt(min));
        }
      }
    } else {
      return fallback;
    }
    if (!isValid(d)) return fallback;
    return fnsFormat(d, formatStr);
  } catch (e) {
    return fallback;
  }
}

/**
 * Safe Date constructor
 */
export function safeDate(dateValue) {
  if (!dateValue) return null;
  try {
    if (dateValue instanceof Date) return isValid(dateValue) ? dateValue : null;
    const d = parseISO(dateValue);
    if (isValid(d)) return d;
    // Try DD/MM/YYYY
    const match = String(dateValue).match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})\s*(\d{1,2})?:?(\d{2})?/);
    if (match) {
      const [, day, month, year, hour = '0', min = '0'] = match;
      return new Date(year, parseInt(month) - 1, parseInt(day), parseInt(hour), parseInt(min));
    }
    return null;
  } catch {
    return null;
  }
}
